<template>
  <li class="nav-item pe-4">
    <router-link
      class="nav-link flex items-center font-medium py-2 px-4 lg:py-0 text-primary"
      :to="{ name: props.to }"
    >
      <span class="shrink-0 me-2">
        <i class="fa-solid text-xs text-primary" :class="props.icon"></i>
      </span>
      <span class="grow">{{ props.title }} </span>
    </router-link>
  </li>
</template>
<script setup>
import { defineProps } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    required: true,
  },
});
</script>
